import { IStyle } from "./../../Types/Style";
import { ICourseStyle } from "./../../components/course-author/types";
import { ICompleteOrganization } from "./../types/common";
import {
  IOrganizationState,
  hasErrorRecords,
  resolveStylePostSuccessResponseValueToStyle,
} from "./../../parsers/resolve";
import { IResolveResponse } from "./../../api/ResolveApi/resolve-api.types";
import { AxiosInterceptedResult } from "./../../api/interceptors";
import { call } from "redux-saga/effects";
import { dependencies } from "../../dependencies";
const { api } = dependencies;

export type GetStyleResponse = [string, null] | [null, IStyle];
export type GetOrganizationResponse = [string, null] | [null, ICompleteOrganization];

export function* _getOrganizationById(organizationId: string, accountId: string) {
  const [err, resp]: AxiosInterceptedResult<Array<IResolveResponse<IOrganizationState>>> = yield call(
    api.resolve.organization.post,
    accountId,
    [organizationId],
    organizationId
  );
  if (err || !resp || !resp.data.length) {
    return ["Error fetching organization", null];
  }
  if (hasErrorRecords(resp.data)) {
    return ["Error fetching organization", null];
  }
  const data = resp.data[0];
  const organization: ICompleteOrganization = {
    admins: data.value.state.admins,
    aliases: data.value.state.aliases,
    defaultLocale: data.value.state.defaultLocale,
    deleted: data.value.state.deleted,
    displayName: data.value.state.displayName,
    organizationId,
    owner: data.value.state.owner,
    releaseLine: data.value.state.releaseLine,
    scormSettings: data.value.state.scormSettings,
    storeLearnerLog: data.value.state.storeLearnerLog,
    style: data.value.state.style,
    versionId: data.value.versionId,
  };
  return [err, organization];
}

export function* _getStyleById(styleId: string, accountId: string) {
  const [err, resp]: AxiosInterceptedResult<Array<IResolveResponse<ICourseStyle>>> = yield call(
    api.resolve.style.post,
    accountId,
    [styleId]
  );
  if (err || !resp || !resp.data.length) {
    return ["Error fetching style", null];
  }

  if (hasErrorRecords(resp.data)) {
    return ["Error fetching style", null];
  }
  const data = resp.data[0];
  const style = resolveStylePostSuccessResponseValueToStyle(styleId, data);
  return [err, style];
}
